import { Button, Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { icon } from '@mage-ui/styled-system/recipes';
import {
  anchorNavigationButton,
  anchorNavigationButtonInner,
  anchorNavigationDropdown,
  anchorNavigationItem,
  anchorNavigationItemSection,
} from '@mage-ui/styled-system/recipes';
import { Menu as MantineMenu } from '@mantine/core';
import { useState } from 'react';

export const AnchorNavigation = ({
  data,
  classNames,
  withArrow,
  isRelation,
  ...props
}) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const displayLabel =
    selectedItem ??
    data.label ??
    (data.items?.[0]?.fields?.title || data.items?.[0]?.title || '');

  return (
    <MantineMenu
      offset={0}
      withinPortal={false}
      keepMounted={true}
      menuItemTabIndex={0}
      {...props}
    >
      <MantineMenu.Target>
        <Button
          type='button'
          aria-selected={!!selectedItem || null}
          endSlot={
            <Icon
              name='arrow_downward'
              classNames={icon({ size: 'm' })}
              aria-hidden='true'
            />
          }
          classNames={{
            root: cx(classNames, anchorNavigationButton()),
            inner: cx(
              classNames,
              anchorNavigationButtonInner({ variant: 'primary' }),
            ),
          }}
        >
          {displayLabel}
        </Button>
      </MantineMenu.Target>
      <MantineMenu.Dropdown
        classNames={{
          dropdown: cx(
            classNames,
            anchorNavigationDropdown({
              variant: isRelation ? 'inner' : 'outer',
            }),
          ),
        }}
      >
        {data.items.map((item) => {
          const itemHref = item?.fields?.href || item.href;

          if ((item?.fields?.title || item.title) === undefined) {
            return null;
          }

          return (
            <MantineMenu.Item
              key={item?.fields?.href || item.title}
              onClick={() => setSelectedItem(itemHref)}
              component='a'
              href={item?.fields?.href || item.href}
              aria-selected={selectedItem === itemHref || null}
              rightSection={
                withArrow ? (
                  <Icon
                    name='arrow_downward'
                    classNames={icon({ size: 'm' })}
                    aria-hidden='true'
                  />
                ) : null
              }
              classNames={{
                item: cx(classNames, anchorNavigationItem()),
                itemSection: withArrow ? anchorNavigationItemSection() : '',
              }}
            >
              <span>{item?.fields?.title || item.title}</span>
            </MantineMenu.Item>
          );
        })}
      </MantineMenu.Dropdown>
    </MantineMenu>
  );
};
